import { ChangeEvent, FunctionComponent, useState } from 'react';
import { Modal } from '../ui/modal';
import { TEventFormData } from '../../types/event';
import Form from '../form/Form';
import Label from '../form/Label';
import Input from '../form/input/InputField';
import TextArea from '../form/input/TextArea';
import Button from '../ui/button/Button';
import Select from '../form/Select';

export const CreateEventModal: FunctionComponent<{
  isOpen: boolean;
  onClose: VoidFunction;
  onSubmit: (values: TEventFormData, successCallback?: VoidFunction) => void;
  isLoading: boolean;
}> = ({ isOpen, onSubmit, onClose, isLoading }) => {
  const init: TEventFormData = {
    name: '',
    description: '',
    time: '',
    scope: 'all',
    registrationLink: undefined,
    virtualLink: undefined,
  };
  const [values, setValues] = useState<TEventFormData>(init);

  const onChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    setValues((prev) => ({ ...prev, [name]: value || null }));
  };

  const onSimpleValueChange = (value: string, name: keyof typeof values) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-[700px]">
      <Form
        onSubmit={() => {
          onSubmit(values, () => {
            setValues(init);
            onClose();
          });
        }}
        className="p-6"
      >
        <div className="my-2">
          <Label>Name</Label>
          <Input
            type="text"
            name="name"
            onChange={onChange}
            required
            value={values.name}
          />
        </div>
        <div className="my-2">
          <Label>Description</Label>
          <TextArea
            value={values.description}
            onChange={(value) => onSimpleValueChange(value, 'description')}
            rows={6}
            placeholder="Enter Description"
            required
          />
        </div>
        <div className="my-2">
          <Label>Scope</Label>
          <Select
            options={[
              { label: 'All', value: 'all' },
              { label: 'Custom', value: 'custom' },
            ]}
            defaultValue={values.scope}
            placeholder="Select Option"
            onChange={(value) => onSimpleValueChange(value, 'scope')}
            className="dark:bg-dark-900"
          />
        </div>
        <div className="my-2">
          <Label>Time</Label>
          <Input
            type="datetime-local"
            name="time"
            onChange={onChange}
            required
            value={values.time}
          />
        </div>
        <div className="my-2">
          <Label>Registration Link (Optional)</Label>
          <Input
            type="url"
            name="registrationLink"
            onChange={onChange}
            required={false}
            value={values.registrationLink ?? ''}
          />
        </div>
        <div className="my-2">
          <Label>Virtual Link (Optional)</Label>
          <Input
            type="url"
            name="virtualLink"
            onChange={onChange}
            required={false}
            value={values.virtualLink ?? ''}
          />
        </div>
        <Button
          variant="primary"
          className="mt-4"
          size="sm"
          disabled={isLoading}
        >
          Submit
        </Button>
      </Form>
    </Modal>
  );
};
